import React from 'react';
import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { palette } from '../../constants/styles';
import Text from './Text';
import GetStarted from '../landing/GetStarted';
import { getCampaign } from '../../constants/utils';
import Title from './Title';
import LazyLoad from 'react-lazyload';

const StyledStartPlanContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  color: #022759;
  border-radius: 1em;
  align-items: flex-start;
  padding: 0.5em 1em;
  margin: 0px 10px 0px 10px;
`;

const StyledCTA = css`
  align-self: center;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledLink = styled(Link)`
  align-self: flex-end;
  color: ${palette.terciaryColor};
`;

const StyledGifContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const StyledGifFrame = styled.img`
  position: absolute;
  z-index: 950;
  align-self: flex-end;
  max-width: 172px;
  height: auto;
  align-self: center;
`;
const StyledThumbnail = styled.img`
  position: absolute;
  margin-top: -310px;
  align-self: flex-end;
  max-width: 140px;
  height: auto;
  align-self: center;
  margin-bottom: 20px;
  margin-top: 21px;
`;
const StyledGif = styled.img`
  position: relative;
  margin-top: -310px;
  align-self: flex-end;
  max-width: 140px;
  height: auto;
  align-self: center;
  margin-bottom: 20px;
  margin-top: 62px;
`;

const StartPlanResultCTA = (props) => (
  <StyledStartPlanContainer>
    <Title
      level={4}
      align="center"
      style={{ width: '100%', marginBottom: '0px', marginTop: '0px' }}
    >
      Obtén un plan para mejorar tus finanzas
    </Title>
    <Text
      type="reference"
      align="left"
      color={palette.primaryColor}
      style={{ marginBottom: '10px', width: '80%', alignSelf: 'center' }}
    >
      Descubre las áreas de oportunidad de tus finanzas y obtén un plan para mejorarlas.
    </Text>
    <StyledGifContainer>
      <StyledGifFrame src="https://finauta.s3.us-east-2.amazonaws.com/png/iphoneFrame.png" />
      <StyledThumbnail src="https://finauta.s3.us-east-2.amazonaws.com/tools/plan.jpg" />
      <StyledGif src="https://finauta.s3.us-east-2.amazonaws.com/gifs/6.gif" />
    </StyledGifContainer>
    <GetStarted
      showExample
      event={`[${getCampaign(window.location.href)}] | Retiro | Inicia Diagnostico`}
      customMessage="Anónimo, gratuito y en menos de 5 minutos"
      styles={StyledCTA}
      incentiveColor={palette.secondaryColor}
    />
  </StyledStartPlanContainer>
);

export default StartPlanResultCTA;
